(function () {

	const pathname = window.location.hostname;
	const productListRef = '#main-collection-product-grid';
	const baseUrl = '//' + pathname;
	const urlWithoutParams = document.URL.split("?")[0];
	const urlParts = urlWithoutParams.split("/");
	const urlParams = new URLSearchParams(window.location.search);
	const sortParam = urlParams.get('sort_by');
	let sortOrder = sortParam ? '?sort_by=' + sortParam : '';
	let tagString = urlParts[5] ? '/' + urlParts[5] : '';
	let collectionString = '/' + urlParts[3] + '/' + urlParts[4];
	let swatchColor = '';

	/* ---------------------------------------------
	HELPER FUNCTIONS
	------------------------------------------------ */
	function clearStr(str) {
		var full = '';

		str.replace(/([^"]+)|("[^"]+")/g, function ($0, $1, $2) {
			if ($1) {
				full += $1;
			} else if ($2) {
				full += $2.replace(/\s/g, '_');
			} else if ($0) {
				full += $0.replace(/\s/g, '_');
			}
		});

		return full;
	}



	// RESET ANIMATIONS
	function resetAnimations() {
		$('[data-stagger]').css('opacity', '1');

		ScrollTrigger.batch('.card-wrapper', {
			onEnter: batch => gsap.to(batch, .8, { autoAlpha: 1, y: 0, stagger: 0.08, ease: Power1.easeOut }),
			start: "40px bottom",
		});
	}

	// AJAX TO UPDATE RESULTS
	function ajaxUpdateResults(requestUrl, sortOrder = '') {
		// ADD LOADING STYLES
		addLoadingStyles();

		// FILTERING BY "OR"
		var productTileTemplateUrl = requestUrl + (requestUrl.includes('?') ? '' : '?') + sortOrder;
		var resultPromise = fetch(productTileTemplateUrl).then(function (res) {
			return res.text();
		});
		resultPromise.then(function (response) {
			$(productListRef).find('.card-wrapper').remove();
			$(productListRef).addClass('has-filtered');

			if (response && response.trim() != '') {
				const parser = new DOMParser();
				const html = parser.parseFromString(response, "text/html");
				const cards = html.querySelectorAll(productListRef + ' .card-wrapper')

				for (var i = 0; i < cards.length; i += 1) {
					$(productListRef).append(cards[i]);
				}

				if (swatchColor != '') {
					filterByColor();
				}

				removeLoadingStyles();

				const paginationData = JSON.parse(html.querySelector('#CollectionProductGridPagination').innerHTML);
				window.ShCustom = paginationData;
				$(window).off('scroll.hasMore');
				// $('.load-more-row').remove();

				resetAnimations();
				window.scrollTo(0, 0)

				if (!window.ShCustom.initialNextUrl) {
					$('.pagination-wrapper, .load-more-row').hide();
				} else {
					$('.pagination-wrapper, .load-more-row').show();
				}
			} else {
				removeLoadingStyles();
				addErrorStyles();
			}

		}).catch(function (error) {
			removeLoadingStyles();
			addErrorStyles('Failed to perform search. Check your internet connection and try again.');
		});
	}

	function addErrorStyles(message) {
		if (!message) {
			var errorMessage = $('.js-filter-error').attr('data-message');
		} else {
			var errorMessage = message;
		}

		$(productListRef).hide();
		$('.js-filter-error').html(errorMessage);
		$('.js-filter-error').fadeIn();

		removeLoadingStyles();
	}

	function clearErrorStyles() {
		$(productListRef).show();
		$('.js-filter-error').hide();
		removeLoadingStyles();
	}

	function addLoadingStyles() {
		$('body').addClass('filters-loading');
	}

	function removeLoadingStyles() {
		$('body').removeClass('filters-loading');
	}

	function undoSort() {
		sortOrder = '';
	}

	/* ---------------------------------------------
	EVENTS
	------------------------------------------------ */

	/*=========================
	Radio change - SORT
	===========================*/
	$('.js-sort-list input[type="radio"]').on('change', function () {
		closeAllDropdowns();
		closeFilters();
		var $sortEl = $('input[name="sortCollection"]:checked');
		var sortText = $sortEl.siblings('label').text();
		var sortCategory = $sortEl.val();

		$('.filter-row__sort-trigger .sort-text').text(sortText);

		// Reset sort order
		tagString = [];
		$('.js-filter-checkbox:checked').each(function () {
			tagString.push(this.name + '=' + this.value)
		})
		var requestUrl = window.ShCustom.paginationBaseUrl + '?' + tagString.join('&');
		undoSort();

		sortOrder = '&sort_by=' + sortCategory;
		ajaxUpdateResults(requestUrl, sortOrder);
	});

	/*================================
	OPEN / CLOSE FILTER BAR - MOBILE
	=================================*/
	function openFilters(self) {
		const sectionToShow = $(self).data('filter-section');
		const activeSection = $('.js-filter-section[data-filter-section="' + sectionToShow + '"]');

		// ADA
		$(activeSection).attr('aria-expanded', 'true');

		// Fade in filters, then fade in appropriate filter section.
		$('body').addClass('open-collection-filters');

		// Show correct menu section
		$('.active-section').removeClass('active-section');
		$(activeSection).addClass('active-section');

		// Make button active (show "hide" text)
		$('.active-link').removeClass('active-link');
		$(self).addClass('active-link');
	}

	if (tagString) {
		openFilters($('.js-toggle-collection-filter[data-filter-section="filter"]'))
	}

	// CLOSE FILTERS
	function closeFilters(self) {
		$('.active-section').attr('aria-expanded', 'false');

		$('body').removeClass('open-collection-filters');
		$('.active-section').removeClass('active-section');
		$('.active-link').removeClass('active-link');
	}

	// TOGGLE FILTERS
	$('.js-toggle-collection-filter').on('click', function (e) {
		e.preventDefault();
		var self = this;
		$('html,body').scrollTop(0);
		setTimeout(function () {
			const headerOffset = $('.header-wrapper').offset().top;
			const headerBottom = headerOffset + $('.header-wrapper').innerHeight() - 1;
			$('.js-filter-section').css('padding-top', (headerBottom + 30) + 'px');
			if ($('body').hasClass('open-collection-filters')) {
				$('body').removeClass('open-collection-filters')
				closeFilters(self);
				closeAllDropdowns();
			} else {
				openFilters(self);
			}
		}, 30);
	});

	/*===============================
	OPEN / CLOSE FILTER "DROPDOWNS"
	=================================*/
	function closeAllDropdowns() {
		$('.dropped-down').removeClass('dropped-down');
		$('.filter-row__sort-dropdown').attr('aria-expanded', 'false');
		$('.filter-row__filter-dropdown').attr('aria-expanded', 'false');
	}

	$('.filter-row__filter-trigger').on('click', function () {
		$parentWrap = $(this).closest('.filter-row__filter-list-item');
		if ($parentWrap.hasClass('dropped-down')) {
			closeAllDropdowns();
		} else {
			closeAllDropdowns();
			$parentWrap.addClass('dropped-down');
			$parentWrap.find('.filter-row__filter-dropdown').attr('aria-expanded', 'true');
		}

		$('body').on('click.closeDropdown', function (e) {
			if ($(e.target).closest('.js-filter-section').length == 0) {
				closeFilters();
				closeAllDropdowns();
				$('body').off('click.closeDropdown');
			}
		});
	});

	$('.filter-row__sort-trigger').on('click', function () {
		$parentWrap = $(this).closest('.filter-row__sort');
		if ($parentWrap.hasClass('dropped-down')) {
			closeAllDropdowns();
		} else {
			closeAllDropdowns();
			$parentWrap.addClass('dropped-down');
			$parentWrap.find('.filter-row__sort-dropdown').attr('aria-expanded', 'true');
		}

		$('body').on('click.closeDropdown', function (e) {
			if ($(e.target).closest('.js-filter-section').length == 0) {
				closeFilters();
				closeAllDropdowns();
				$('body').off('click.closeDropdown');
			}
		});

	});

	// FILTER BY COLOR
	function filterByColor() {
		if (swatchColor != '') {
			$('.card-wrapper').each(function () {
				// If a swatch is selected
				const newImageSrc = $(this).find('.js-all-image-sources').attr('data-' + swatchColor);
				if (newImageSrc) {
					$(this).find('.js-featured-image').attr('src', newImageSrc);
					$(this).find('.js-featured-image').attr('srcset', '');
					$(this).find('.collection-swatches').find('.active').removeClass('active');
				} else {
					$(this).hide();
				}

			});
			$('.collection-swatches [data-swatch-color="' + swatchColor + '"] .collection-swatches__swatch').addClass('active');
		} else {
			$('.card-wrapper').each(function () {
				// If a swatch is selected
				const newImageSrc = $(this).find('.js-all-image-sources').attr('data-default');
				if (newImageSrc) {
					$(this).find('.js-featured-image').attr('src', newImageSrc);
					$(this).find('.js-featured-image').attr('srcset', '');
					$(this).find('.collection-swatches').find('.active').removeClass('active');
					$(this).find('.js-default').addClass('active');
				}

			});
		}
	}

	/*=========================
	FILTER CHECKBOX
	===========================*/
	$('.js-filter-checkbox').on('change', function () {
		closeFilters();
		closeAllDropdowns();
		clearErrorStyles();

		// UPDATE CLEAR ALL UI & PAGINATION UI
		if ($('.js-filter-checkbox:checked').length > 0 || $('.js-filter-color:checked').length > 0) {
			$('.js-clear-all-filters').fadeIn();
		} else {
			$('.js-clear-all-filters').hide();
		}

		tagString = [];
		$('.js-filter-checkbox:checked').each(function () {
			tagString.push(this.name + '=' + this.value)
		})
		var requestUrl = window.ShCustom.paginationBaseUrl + '?' + tagString.join('&');

		ajaxUpdateResults(requestUrl, sortOrder);

	});

	$('.js-filter-color').on('change', function (e) {
		closeFilters();
		closeAllDropdowns();
		clearErrorStyles();

		// UPDATE CLEAR ALL UI & PAGINATION UI
		if ($('.js-filter-checkbox:checked').length > 0 || $('.js-filter-color:checked').length > 0) {
			$('.js-clear-all-filters').fadeIn();
		} else {
			$('.js-clear-all-filters').hide();
		}

		swatchColor = e.target.value;
		filterByColor();
	});

	/*=========================
	CLEAR FILTERS
	===========================*/
	$('.js-clear-all-filters').on('click', function (e) {
		e.preventDefault();
		$('.js-clear-all-filters').hide();
		// $('.pagination-wrapper').fadeIn();
		closeAllDropdowns();
		clearErrorStyles();
		$('.js-filter-section input:checkbox').prop('checked', false);
		$('.js-filter-section input:radio').prop('checked', false);

		if (swatchColor !== '') {
			swatchColor = '';
			filterByColor();
		}

		tagString = '';
		var requestUrl = baseUrl + collectionString + tagString;

		ajaxUpdateResults(requestUrl, sortOrder);
	});

	if (window.ShCustom.currentPage == 1 && window.ShCustom.totalPosts > window.ShCustom.postsPerPage) {

		// REFS
		const productListRef = '#main-collection-product-grid';

		// TOGGLED WHILE WAITING FOR A REQUEST TO LOAD TO PREVENT DUPLICATE REQUESTS
		var gAjaxStatus = false;

		function clearStr(str) {

			var full = '';

			str.replace(/([^"]+)|("[^"]+")/g, function ($0, $1, $2) {
				if ($1) {
					full += $1;
				} else if ($2) {
					full += $2.replace(/\s/g, '_');
				} else if ($0) {
					full += $0.replace(/\s/g, '_');
				}
			});

			return full;
		}


		// AJAX LOAD NEXT PAGE ======================
		function ajaxLoadNextPage() {
			var paginationNextUrl = window.ShCustom.initialNextUrl;
			if (!paginationNextUrl) return;

			$.ajax({
				type: 'GET',
				dataType: 'html',
				url: paginationNextUrl,
				success: function (data) {

					// GET HTML FROM RESPONSE (Will contain entire HTML page fragment)
					// Find the journal list from the next page
					var filteredData = $(data).find(productListRef).html();

					$(productListRef).append(filteredData);

					if (swatchColor != '') {
						filterByColor();
					}

					resetAnimations();

					// SET LOADING TO FALSE
					gAjaxStatus = false;
					removeLoadingStyles();

					const paginationData = JSON.parse($(data).find('#CollectionProductGridPagination').html());
					window.ShCustom = paginationData;

					if (window.ShCustom.totalPosts <= window.ShCustom.currentPage * window.ShCustom.postsPerPage) {
						// $('.has-pagination').removeClass('has-pagination');
						// $('.js-load-more').remove();
						$(window).off('scroll.hasMore');
					}
				}
			});
		}

		function loadMorePosts() {

			var currentPage = window.ShCustom.currentPage;
			// If page has pagination
			// If total items is greater than page number times number posts per page

			if (!gAjaxStatus && window.ShCustom.totalPosts > currentPage * window.ShCustom.postsPerPage) {
				gAjaxStatus = true;

				// LOAD NEXT PAGE
				ajaxLoadNextPage();
			}
		}

		// ENDLESS SCROLL ======================
		$('.js-load-more').on('click', function () {
			// SHOW LOADING ICON
			addLoadingStyles();

			loadMorePosts();
		});

		// $(window).on('scroll.hasMore', function () {
		// 	if ($(window).scrollTop() >= $('.js-load-more').offset().top - $(window).innerHeight()) {
		// 		$('.js-load-more').text('Loading More...');
		// 		loadMorePosts();
		// 	}
		// });
	}
})();
